import React from 'react';
import { Heading, Flex } from '@spothero/ui';
import { DriverTagChip } from './DriverTagChip';
export const DriverTagsList = ({ prompts, }) => {
    const tags = prompts ?? [];
    const visibleTags = tags.filter(tag => tag.count >= 1);
    if (visibleTags.length === 0) {
        return null;
    }
    return (<>
            <Heading as="h6" fontWeight="semibold" fontSize="sm" marginBottom={2}>
                What Drivers Like
            </Heading>
            <Flex flexWrap="wrap" gap={2} marginBottom={3} data-testid="DriverTagsList">
                {visibleTags.map(tag => (<DriverTagChip key={tag.name} emoji={tag.emoji} label={tag.name} count={tag.count}/>))}
            </Flex>
        </>);
};
